export function sortObjectsInArrayByKeyName(
  initialArray,
  keyName,
  order = "ascending",
) {
  const sortedArray = [...initialArray];
  if (order === "ascending") {
    sortedArray.sort((a, b) => (a[keyName] > b[keyName] ? 1 : -1));
  }
  if (order === "descending") {
    sortedArray.sort((a, b) => (a[keyName] < b[keyName] ? 1 : -1));
  }
  return sortedArray;
}
